export default {
  abtestToggleState: function abtestToggleState(state) {
    return state.abtestToggleState;
  },
  abtestToggleTooltypeState: function abtestToggleTooltypeState(state) {
    return state.abtestToggleTooltypeState;
  }
};